export default {
  title: 'Alterar Disponibilidade',
  amend_availabilities_form: {
    date: {
      label: 'Selecionar uma Data',
    },
    times: {
      label: 'Turnos e horários de abertura',
      description:
        'Defina os horários de abertura para a data selecionada. Torne os turnos mais longos, mais curtos ou bloqueie-os. Pelo menos um turno deve estar aberto.',
      breakfast: {
        label: 'Pequeno-almoço',
      },
      lunch: {
        label: 'Almoço',
      },
      dinner: {
        label: 'Jantar',
      },
    },
  },
  reason: {
    label: 'Adicionar um motivo (opcional)',
    placeholder: 'Inserir descrição...',
  },
  buttons: {
    save: 'Guardar',
  },
  projects: {
    online_shop: 'Loja Online',
    reservations: 'Reservas',
    storefront: 'Storefront',
  },
  error_messages: {
    creation_failed: 'Falha ao criar exceção',
  },
};
